import { createNextTableContext } from '@shared/modules/next-table/context/context'

export const ProductCategoriesTableContext = createNextTableContext()
export const ProductsTableContext = createNextTableContext()
